"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _btoa = _interopRequireDefault(require("btoa"));

var _DAO2 = _interopRequireDefault(require("./_DAO"));

var _utils = require("./_utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var InstanceConfig = {};

var AuthService = /*#__PURE__*/function (_DAO) {
  (0, _inherits2["default"])(AuthService, _DAO);

  var _super = _createSuper(AuthService);

  function AuthService() {
    (0, _classCallCheck2["default"])(this, AuthService);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(AuthService, [{
    key: "_createUrl",

    /**
     * Helper method to create the share api url
     * @param {String} resourceUrl
     */
    value: function _createUrl(resourceUrn) {
      if (!resourceUrn && this.apiVersion.toUpperCase() === 'V4') {
        throw new Error('Missing Resource URN');
      }

      if (resourceUrn) {
        return this.apiVersion.toUpperCase() === 'V4' ? "".concat(this.endpoint, "/auth/").concat(encodeURIComponent(resourceUrn)) : "".concat(this.endpoint, "/auth/urn/").concat(encodeURIComponent(resourceUrn));
      }
    }
    /**
     * @param {Object} request - auth request object
     *   @property {Boolean} cdnAcceleration - Whether to return CDN URLs. Note CDN URLs can only be used for read access.
     *   @property {String} resourceUrn - resource urn.
     *   x-sharing-password: required when accessing a password protected public resource. Base64 encoded.
     *   @property {String} sharingPassword - auth password.
     */

  }, {
    key: "get",
    value: function get() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _request$cdnAccelerat = request.cdnAcceleration,
          cdnAcceleration = _request$cdnAccelerat === void 0 ? false : _request$cdnAccelerat,
          resourceUrn = request.resourceUrn,
          sharingPassword = request.sharingPassword;

      var url = this._createUrl(resourceUrn);

      var params = {
        cdnAcceleration: cdnAcceleration
      };
      var password = sharingPassword || this.sharingPassword;
      var headers = password ? {
        'X-Sharing-Password': (0, _btoa["default"])(password)
      } : null;

      if (!resourceUrn) {
        throw new Error('Missing Resource Urn');
      }

      return this.getRequest({
        url: url,
        headers: headers,
        params: params
      });
    }
  }]);
  return AuthService;
}(_DAO2["default"]);

var _default = (0, _utils.InstanceCreator)(AuthService, InstanceConfig);

exports["default"] = _default;